
import dhtmlx from '../../global/dhtmlx';

var dhtmlxArray = (function () {
    function dhtmlxArray(a) {
        return dhtmlx.extend(a || new Array(), dhtmlxArray._master);
    }
    return dhtmlxArray;
})();
dhtmlxArray._master = {
    _dhx_find: function (c) {
        for (var a = 0; a < this.length; a++) {
            if (c == this[a]) {
                return a;
            }
        }
        return -1;
    },
    _dhx_insertAt: function (e, c) {
        this[this.length] = null;
        for (var a = this.length - 1; a >= e; a--) {
            this[a] = this[a - 1];
        }
        this[e] = c;
    },
    _dhx_removeAt: function (a) {
        this.splice(a, 1);
    },
    _dhx_swapItems: function (a, e) {
        var c = this[a];
        this[a] = this[e];
        this[e] = c;
    }
};

export default dhtmlxArray;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dhtmlxArray.js